module.exports = __webpack_public_path__ + "img/owl-blue-front.b4a1e607.png";